import { QlikUIContext, QlikWrapper, Report } from 'globaleris-qlik-component'
import 'globaleris-qlik-component/dist/index.css'
import { Button } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import Page from '../../../components/page/page'
import PageHeader from '../../../components/page/pageHeader'
import { useQlikContext } from '../../../hooks/useQlikContext'
import { AppConfigurationKey } from '../../../model/enums/appConfigurationKey'
import { EnumCommodity } from '../../../api/Argentia/enums'
import { getAppConfigurationValue } from '../../../redux'

interface LocationState {
  leadId?: number
  commodity?: EnumCommodity
}

export const LeadsReportPage: React.FC = () => {
  const [t] = useTranslation(['globalerisLibrary', 'leadsReport'])
  const { isContextInitialized, context } = useQlikContext()
  const history = useHistory()
  const location = useLocation<LocationState>()
  const leadId = location.state?.leadId
  const commodity = location.state?.commodity

  const fileName =
    commodity === EnumCommodity.Electricidad
      ? getAppConfigurationValue(AppConfigurationKey.EmbeddedReportLeadsElectricity)
      : getAppConfigurationValue(AppConfigurationKey.EmbeddedReportLeadsGas)

  return (
    <Page>
      <PageHeader title={`${t('leadsReport:title')}`}>
        <Button
          variant="text"
          color="primary"
          onClick={() => {
            history.goBack()
          }}
        >
          {t('Volver')}
        </Button>
      </PageHeader>
      {isContextInitialized && (
        <QlikUIContext.Provider value={context}>
          {
            <QlikWrapper
              component={
                <Report
                  fileName={fileName}
                  reportType={1}
                  dimensions={[{ Dimension: 'ID_LEAD', Value: `${leadId}` }]}
                />
              }
            />
          }
        </QlikUIContext.Provider>
      )}
    </Page>
  )
}
